export default function WebIframe({ src, style }) {
    return (<iframe src={src} style={style}></iframe>);
}

  